const DEFAULT_LANG = 'en';
const FM_LANGS = ['fr', 'es', 'en', 'de', 'pt', 'it'];

function getLangFromLocationSearch() {
    return new URLSearchParams(window.location.search).get('lang');
}

/** Hash router URLs put query after the path: #/route?lang=es — not in window.location.search */
function getLangFromHashSearch() {
    const hash = window.location.hash ?? '';
    const queryStart = hash.indexOf('?');
    if (queryStart === -1) return null;
    return new URLSearchParams(hash.slice(queryStart + 1)).get('lang');
}

export function getLang() {
    const langFromSearch = getLangFromLocationSearch() ?? getLangFromHashSearch();
    if (langFromSearch) return langFromSearch;

    let userLang = navigator.language || navigator.userLanguage;
    userLang = userLang.substring(0, 2);
    if (FM_LANGS.includes(userLang)) return userLang;
    else return DEFAULT_LANG;
}
